module.exports = __webpack_public_path__ + "static/media/tasklevel1.b67b5c0f.png";